import { createQueryData } from '../helpers/createQueryData';

const { useQuery, createKey, fn } = createQueryData({
  endPoint: 'Acceptance/view_calendar_get_clients_by_address_id',
});

export const useAddressOwnersQuery = ({
  params: { addressId } = {},
  options,
} = {}) => {
  return useQuery({
    params: { addressId },
    options: { enabled: Boolean(addressId), staleTime: 0, ...options },
  });
};

export const addressOwnersFetch = ({
  queryClient,
  params: { addressId },
  options,
}) => {
  return queryClient.fetchQuery(
    createKey({ addressId }),
    () => fn({ addressId }),
    options
  );
};
